"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = sleep;
function sleep(timeInMs) {
    return new Promise((resolve) => setTimeout(resolve, timeInMs));
}
//# sourceMappingURL=sleep.js.map